import { PageUsage } from "./PageUsage";

export class PageUsages extends Map<string, PageUsage> {
  compareTo(other: PageUsages): string[] {
    return Array.from(this.entries()).flatMap((map) => {
      const thisItem = this.get(map[0]);
      const otherItem = other.get(map[0]);

      if (thisItem && otherItem) {
        return thisItem.compareTo(otherItem);
      }
      return [`${map[0]} different`];
    });
  }

  fromJSON(data: any[]): void {
    data.map((item) => {
      const pu = new PageUsage();
      pu.fromJSON(item);
      this.set(pu.pageId, pu);
    });
  }

  toJSON(): any {
    const result = Array();
    this.forEach((item) => result.push(item.toJSON()));
    return result;
  }
}
